import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";
import axios from "axios";

export const SET_CSV_ONE_LINE_HEADERS = "SET_CSV_ONE_LINE_HEADERS";
export const SET_CSV_ONE_LINE_HIDDEN_HEADERS = "SET_CSV_ONE_LINE_HIDDEN_HEADERS";
export const SET_CSV_MULTI_LINE_HEADERS = "SET_CSV_MULTI_LINE_HEADERS";
export const SET_CSV_MULTI_LINE_HIDDEN_HEADERS = "SET_CSV_MULTI_LINE_HIDDEN_HEADERS";
export const SET_CSV_ONE_LINE_FIELD_VALUES = "SET_CSV_ONE_LINE_FIELD_VALUES";
export const SET_EXCEL_HEADERS = "SET_EXCEL_HEADERS";
export const SET_EXCEL_HIDDEN_HEADERS = "SET_EXCEL_HIDDEN_HEADERS";
export const FIRST_EXCEL_CALL = "FIRST_EXCEL_CALL";

const state = () => ({
    csv_one_line_headers: [],
    csv_one_line_hidden_headers: [],
    csv_multi_line_headers: [],
    csv_multi_line_hidden_headers: [],
    excel_headers:[],
    excel_hidden_headers:[],
    first_excel_call:true,
    csv_one_line_field_values: {"kind": { "in_invoice": "", "out_invoice": "" }},
});

const getters = {
    getField,
}

const mutations = {
    updateField,
    [SET_CSV_ONE_LINE_HEADERS](state, headers) {
        state.csv_one_line_headers = headers;
    },
    [SET_CSV_ONE_LINE_HIDDEN_HEADERS](state, headers) {
        state.csv_one_line_hidden_headers = headers;
    },
    [SET_CSV_MULTI_LINE_HEADERS](state, headers) {
        state.csv_multi_line_headers = headers;
    },
    [SET_CSV_MULTI_LINE_HIDDEN_HEADERS](state, headers) {
        state.csv_multi_line_hidden_headers = headers;
    },
    [SET_CSV_ONE_LINE_FIELD_VALUES](state, values) {
        state.csv_one_line_field_values = values;
    },
    [SET_EXCEL_HEADERS](state, headers) {
        state.excel_headers = headers;
    },
    [SET_EXCEL_HIDDEN_HEADERS](state, headers) {
        state.excel_hidden_headers = headers;
    },
    [FIRST_EXCEL_CALL](state) {
        state.first_excel_call = false;
    },
}

const getColumnsCsvOneLine = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/get_setting_csv/csv_facturas_one_line_headers/' + rootGetters["me/userData"]['user'] + '/';
        client.get(url).then(resp => {
            commit(SET_CSV_ONE_LINE_HEADERS, resp.data['params']['show']);
            commit(SET_CSV_ONE_LINE_HIDDEN_HEADERS, resp.data['params']['hide']);
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
};

const setColumnsCsvOneLine = ({ state, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/set_setting/csv_facturas_one_line_headers/' + rootGetters["me/userData"]['user'] + '/';
        let params = { 'payload': { 'show': state.csv_one_line_headers, 'hide': state.csv_one_line_hidden_headers }};
        client.patch(url, params).then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
}

const getColumnsCsvMultiLine = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/get_setting/csv_facturas_multi_line_headers/' + rootGetters["me/userData"]['user'] + '/';
        client.get(url).then(resp => {
            commit(SET_CSV_MULTI_LINE_HEADERS, resp.data['params']['show']);
            commit(SET_CSV_MULTI_LINE_HIDDEN_HEADERS, resp.data['params']['hide']);
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
};

const setColumnsCsvMultiLine = ({ state, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/set_setting/csv_facturas_multi_line_headers/' + rootGetters["me/userData"]['user'] + '/';
        let params = { 'payload': { 'show': state.csv_multi_line_headers, 'hide': state.csv_multi_line_hidden_headers }};
        client.patch(url, params).then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
}
const getColumnsExcel = ({ commit, state,rootGetters },cdb_id) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/get_setting/excel_headers/' + rootGetters["me/userData"]['user'] + '/';
        if (cdb_id){
            url += cdb_id + '/';
        }
        client.get(url).then(resp => {
            let show = resp.data['params']['show']
            let hide = resp.data['params']['hide']
            if (state.first_excel_call && rootGetters['me/userData']['available_features']['feature_iva_agrario_pesca_tabaco']){
                let found = false
                for(let i=0;i<show.length && found == false;i++){
                    if (show[i]['value'] == 'base_vat_10_5'){
                        found = true
                    }
                }
                for(let i=0;i<hide.length && found == false;i++){
                    if (hide[i]['value'] == 'base_vat_10_5'){
                        found = true
                    }
                }
                if(found == false){
                    let extra_vats = [{ "value": "base_vat_10_5", "text": "Base IVA 10.5%" , "width":150},
                                    { "value": "vat_10_5", "text": "IVA 10.5%" , "width":150},
                                    { "value": "base_vat_12", "text": "Base IVA 12%" , "width":150},
                                    { "value": "vat_12", "text": "IVA 12%" , "width":150}]
                    hide = hide.concat(extra_vats)
                }
            }
            commit(SET_EXCEL_HEADERS, show);
            commit(SET_EXCEL_HIDDEN_HEADERS, hide);
            commit(FIRST_EXCEL_CALL);
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
};
const setColumnsExcel = ({ state, rootGetters },cdb_id) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/set_setting/excel_headers/' + rootGetters["me/userData"]['user'] + '/';
        if (cdb_id){
            url += cdb_id + '/';
        }
        let params = { 'payload': { 'show': state.excel_headers, 'hide': state.excel_hidden_headers }};
        client.patch(url, params).then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
};
const getFieldValuesCsvOneLine = ({ commit, rootGetters },cdb_id) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/get_setting/csv_facturas_one_line_configure_field_values/' + rootGetters["me/userData"]['user'] + '/';
        if (cdb_id){
            url += cdb_id + '/';
        }
        client.get(url).then(resp => {
            commit(SET_CSV_ONE_LINE_FIELD_VALUES, resp.data['params']);
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
}

const setFieldValuesCsvOneLine = ({ state, rootGetters },cdb_id) => {
    return new Promise((resolve, reject) => {
        let url = 'settings/set_setting/csv_facturas_one_line_configure_field_values/' + rootGetters["me/userData"]['user'] + '/';
        if (cdb_id){
            url += cdb_id + '/';
        }
        let params = { 'payload': state.csv_one_line_field_values };
        client.patch(url, params).then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject(err);
        });
    });
}

const setDiezsoftwareCredentials = ({ state, rootGetters }, { softwareType, user, password }) => new Promise((resolve, reject) => {
    const url = `update_profile_default_settings/`

    const params = {
        diezsoftware: {
            software_type: {
                is_enabled: true,
                value: softwareType
            },
            user: {
                is_enabled: true,
                value: user
            },
            password: {
                is_enabled: true,
                value: password
            }
        }
    }

    client.patch(url, params)
        .then((res) => {
            resolve(res) })
        .catch(err => { reject(err) })
})

const setGlasofCredentials = ({ state, rootGetters }, { public_folder, export_folder, automatic_upload_invoice, application_path }) => new Promise((resolve, reject) => {
    const url = `update_profile_default_settings/`

    const params = {
        glasof: {
            public_folder: {
                is_enabled: true,
                value: public_folder
            },
            export_folder: {
                is_enabled: true,
                value: export_folder
            },
            automatic_upload_invoice: {
                is_enabled: true,
                value: automatic_upload_invoice
            },
            application_path: {
                is_enabled: true,
                value: application_path
            },
            // avoid_duplicate_lines: {
            //     is_enabled: true,
            //     value: avoid_duplicate_lines
            // },
            // avoid_duplicate_lines_keys: {
            //     is_enabled: true,
            //     value: avoid_duplicate_lines_keys
            // },
            // order_lines: {
            //     is_enabled: true,
            //     value: order_lines
            // },
            // order_lines_keys: {
            //     is_enabled: true,
            //     value: order_lines_keys
            // }
        }
    }

    client.patch(url, params)
        .then((res) => {
            resolve(res) })
        .catch(err => { reject(err) })
})

const setGoldenCredentials = ({ state, rootGetters }, 

    {   
        export_in_company_folder,
        public_folder,
        db_path,
        db_user,
        db_password,
        db_host,
        db_extension,
        export_folder
    }
    ) => new Promise((resolve, reject) => {
    const url = `update_profile_default_settings/`
    console.log(export_in_company_folder);
    const params = {
        goldennet: {
            export_in_company_folder: {
                is_enabled: true,
                value: export_in_company_folder
            },
            public_folder: {
                is_enabled: true,
                value: public_folder
            },
            con_db_path: {
                is_enabled: true,
                value: db_path
            },
            db_user: {
                is_enabled: true,
                value: db_user
            },
            db_password: {
                is_enabled: true,
                value: db_password
            },
            db_host: {
                is_enabled: true,
                value: db_host
            },
            db_extension: {
                is_enabled: true,
                value: db_extension
            },
            export_folder: {
                is_enabled: true,
                value: export_folder
            },

        }
    }

    client.patch(url, params)
        .then((res) => {
            resolve(res) })
        .catch(err => { reject(err) })
})


const setA3Directories = ({ state }, { directory, exportFolder, automatic_upload_invoice, automatic_upload_transaction }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        con_directory_a3: {
            is_enabled: Boolean(directory),
            value: directory,
        },
        a3: {
            files_directory: {
                is_enabled: Boolean(exportFolder),
                value: exportFolder
            },
            automatic_upload_invoice: {
                is_enabled: Boolean(automatic_upload_invoice),
                value: automatic_upload_invoice
            },
            automatic_upload_transaction: {
                is_enabled: Boolean(automatic_upload_transaction),
                value: automatic_upload_transaction
            }
        }
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
})

const setAplifisaDirectories = ({ state }, { directory, port, dll }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        con_directory_aplifisa: {
            is_enabled: Boolean(directory),
            value: directory,
        },
        con_port_aplifisa: {
            is_enabled: Boolean(port),
            value: port,
        },
        con_dll_aplifisa: {
            is_enabled: Boolean(dll),
            value: dll,
        },
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
})

const setContaplusDirectories = ({ state }, { programFolder, appFolder, exportFolder, newDbfSystem }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        contaplus: {
            con_application_group_path: {
                is_enabled: Boolean(programFolder),
                value: programFolder
            },
            con_application_folder_path: {
                is_enabled: Boolean(appFolder),
                value: appFolder
            },
            con_export_folder: {
                is_enabled: Boolean(exportFolder),
                value: exportFolder
            },
            con_new_read_dbf_system: {
                is_enabled: Boolean(newDbfSystem),
                value: newDbfSystem
            },
        }
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
})

const setContasolDirectories = ({ state }, { dbDriver, directory, directoryDocs, cloudCode }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        // docs_private_folder: {
        //     is_enabled: Boolean(docsPrivateFolder),
        //     value: docsPrivateFolder,
        // },
        con_db_driver_contasol: {
            is_enabled: Boolean(dbDriver),
            value: dbDriver,
        },
        con_directory_contasol: {
            is_enabled: Boolean(directory),
            value: directory,
        },
        con_directory_docs_contasol: {
            is_enabled: Boolean(directoryDocs),
            value: directoryDocs,
        },
        contasol_cloud_codigo_cliente: {
            is_enabled: Boolean(cloudCode),
            value: cloudCode,
        },
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
})

const setOdooCredentials = ({ state }, { user, password, url, database, version }) => new Promise((resolve, reject) => {
    const patchUrl = 'update_profile_default_settings/'
    let params = {}
    
    if (version === 'odoo'){
        params = {
            odoo: {
                con_db: {
                    is_enabled: true,
                    value: database,
                },
                con_url: {
                    is_enabled: true,
                    value: url,
                },
                con_user: {
                    is_enabled: true,
                    value: user,
                },
                con_password: {
                    is_enabled: true,
                    value: password,
                }
            }
        }
    } else if (version === 'odoo18'){
        params = {
            odoo18: {
                con_db: {
                    is_enabled: true,
                    value: database,
                },
                con_url: {
                    is_enabled: true,
                    value: url,
                },
                con_user: {
                    is_enabled: true,
                    value: user,
                },
                con_password: {
                    is_enabled: true,
                    value: password,
                }
            }
        }
    }

    client.patch(patchUrl, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
    // const options = {
    //     method: 'POST',
    //     url: `${url}/jsonrpc`,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: {
    //       jsonrpc: "2.0",
    //       method: "call",
    //       params: {
    //         service: 'common',
    //         method: 'authenticate',
    //         args: [database, user, password, {}],
    //       },
    //     },
    //   };
    //
    // axios(options)
    // .then(response => {
    //     const { result } = response.data;
    //     if (result) {
    //         // If authentication is successful, save the new settings
    //         client.patch(patchUrl, params)
    //             .then(() => { resolve() })
    //             .catch(err => { reject(err) })
    //     } else {
    //         // If authentication failed
    //         reject('Credenciales incorrectas. Por favor, compruebe que los datos introducidos son correctos.');
    //     }
    // })
    // .catch(err => {
    //     console.log('Error: ', err);
    //     reject('No se ha podido conectar con el servidor. Por favor, compruebe que los datos introducidos son correctos.');
    // })
})

const textToLowerCase = ({ state}, value) => {
    return value && value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace('&','').replace('?','').replace('!','').replace('¿','').replace('¡','');
};

const setSageCredentials = ({ state }, { con_db_host, con_db_name }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        sage: {
            con_db_host: {
                is_enabled: Boolean(con_db_host),
                value: con_db_host
            },
            con_db_name: {
                is_enabled: Boolean(con_db_name),
                value: con_db_name
            }
        }
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
});
const setSageeeeCredentials = ({ state }, { con_db_host, con_db_name }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'

    const params = {
        sage: {
            con_db_host: {
                is_enabled: Boolean(con_db_host),
                value: con_db_host
            },
            con_db_name: {
                is_enabled: Boolean(con_db_name),
                value: con_db_name
            }
        }
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
});

const setSageDespCredentials  = ({ state, rootGetters }, 

    {
        con_db_host,
        con_db_name,
        con_db_user,
        con_db_password,
        con_public_folde,
        con_export_documents
    }) => new Promise((resolve, reject) => {
    const url = 'update_profile_default_settings/'
    const params = {
        sage_despachos: {
            con_db_host: {
                is_enabled: true,
                value: con_db_host
            },
            con_db_name: {
                is_enabled: true,
                value: con_db_name
            },
            con_db_user: {
                is_enabled: true,
                value: con_db_user
            },
            con_db_password: {
                is_enabled: true,
                value: con_db_password
            },
            con_public_folde: {
                is_enabled: true,
                value: con_public_folde
            },
            con_export_documents: {
                is_enabled: true,
                value: con_export_documents
            },
        }
    }

    client.patch(url, params)
        .then(() => { resolve() })
        .catch(err => { reject(err) })
});




const actions = {
    getColumnsCsvOneLine,
    setColumnsCsvOneLine,
    getColumnsCsvMultiLine,
    setColumnsCsvMultiLine,
    getColumnsExcel,
    setColumnsExcel,
    getFieldValuesCsvOneLine,
    setFieldValuesCsvOneLine,
    setDiezsoftwareCredentials,
    setA3Directories,
    setAplifisaDirectories,
    setContaplusDirectories,
    setContasolDirectories,
    setOdooCredentials,
    setGlasofCredentials,
    setGoldenCredentials,
    setSageCredentials,
    setSageDespCredentials,
    textToLowerCase,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
